import { MessageSquareWarning } from 'lucide-react';

import { SidebarItem } from './SidebarItem';
import { SidebarSection } from './SidebarSection';

export function ObservabilitySidebar({
  IsObservabilityEnabled,
}: {
  IsObservabilityEnabled: boolean;
}) {
  return (
    <SidebarSection title="Observability">
      <SidebarItem
        label="Alerting"
        to={
          IsObservabilityEnabled ? 'portainer.alerting' : 'portainer.settings'
        }
        params={
          !IsObservabilityEnabled ? { section: 'additional-functionality' } : {}
        }
        icon={MessageSquareWarning}
        data-cy="portainerSidebar-alerting"
      />
    </SidebarSection>
  );
}
